$('body').on('click','.custom-drawer__header',function () {
    var getHanle = $(this).attr('data-handle');
    console.log(getHanle);
    $(`.custom-drawer__content[data-handle='${getHanle}']`).show();
    $('body').addClass('is-body-active');
})

$('body').on('click', '.custom-drawer__content svg, .custom-drawer-btn-outer button', function () {
$(this).parents('.custom-drawer__content').hide();
    $('body').removeClass('is-body-active');
});

// filter click 
$('body').on('click','.collection-tags li',function () {
    var getHanle = $(this).attr('data-menu');
    console.log(getHanle);
    $(`span.facet-checkbox__text-label[data-value='${getHanle}']`).trigger('click');
})
// price updat eonproduct page 

$('body').on('click','.product-form__input',function () {
setTimeout(function() {
 var pricetext = $('span.price-item.price-item--regular.variant-price-regular').attr('data-money');
    console.log(pricetext)
   $('span.product-variant-price').text(pricetext);
     }, 1000);
})
// accoutn darwer
 
      $('body').on('click', 'a.header__icon.header__icon--account', function (e) {
    e.preventDefault();
 $('.account--drawer--wrpper').show();
   $('body').addClass('account-drawer-active');
});
$('body').on('click', '.account--drawer--wrpper svg.icon.icon-close', function (e) {
    e.preventDefault();
 $('.account--drawer--wrpper').hide();
   $('body').removeClass('account-drawer-active');
});
